//test


export default {
  getUserInfo: state => state.userInfo,
  isSuperAdmin: state => state.userInfo && state.userInfo.role === 0,
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js